import React from 'react'
import './seperator.css'

function Separator() {
    return (
        <div className="separator">

        </div>
    )
}

export default Separator
